import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hasMarketingDecision, setMarketingConsent } from "@/lib/marketingConsent";

// Kleines, seriöses Marketing-/Cookie-Consent-Banner. Erscheint nur, solange KEINE
// Entscheidung gespeichert ist. Nutzt ausschließlich die zentrale marketingConsent.js.
// Kein Fullscreen-Zwang, keine Dark Patterns – beide Optionen gleichwertig.
export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setVisible(!hasMarketingDecision()); }, []);
  if (!visible) return null;

  const decide = (granted) => { setMarketingConsent(granted); setVisible(false); };

  return (
    <div
      data-testid="consent-banner"
      className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-2xl rounded-2xl border border-white/10 bg-[#0b1220]/95 p-4 text-white shadow-2xl backdrop-blur-md sm:inset-x-auto sm:right-4 sm:left-auto sm:w-[420px]"
    >
      <p className="text-sm leading-relaxed text-white/85">
        Wir verwenden optionale Marketing-Technologien, um unsere Werbung zu messen und zu
        verbessern. Diese werden nur mit deiner Einwilligung aktiviert.{" "}
        <Link to="/rechtliches/datenschutz" data-testid="consent-privacy-link" className="text-[#3fd6df] underline underline-offset-2 hover:text-[#7be6ec]">
          Datenschutz
        </Link>
      </p>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          data-testid="consent-reject-btn"
          onClick={() => decide(false)}
          className="flex-1 rounded-full border border-white/25 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
        >
          Nur notwendige
        </button>
        <button
          type="button"
          data-testid="consent-accept-btn"
          onClick={() => decide(true)}
          className="flex-1 rounded-full bg-[#3fd6df] px-4 py-2 text-sm font-semibold text-[#06212a] transition-colors hover:bg-[#5fe3ea]"
        >
          Marketing erlauben
        </button>
      </div>
    </div>
  );
}
